import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "error",
    "loading",
    "loadingMessage",
    "success",
    "successMessage"
  ]

  static values = {
    endpoint: String
  }

  connect() {
    this.unlockAccount()
  }

  async unlockAccount() {
    const token = this.unlockToken()

    if (!token) {
      this.showError("This unlock link is missing its token. Request a new unlock email and try again.")
      return
    }

    this.showLoading("Unlocking your account...")

    try {
      const response = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        credentials: "same-origin",
        body: JSON.stringify({
          unlock: {
            unlock_token: token
          }
        })
      })

      const body = await response.json().catch(() => ({}))

      if (!response.ok) {
        this.showError(this.errorMessage(body))
        return
      }

      this.showSuccess("Your account has been unlocked.")
    } catch (_error) {
      this.showError("We couldn't unlock this account right now. Please try again.")
    }
  }

  unlockToken() {
    return new URLSearchParams(window.location.search).get("token") || ""
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""
  }

  showLoading(message) {
    this.loadingMessageTarget.textContent = message
    this.loadingTarget.classList.remove("hidden")
    this.successTarget.classList.add("hidden")
    this.errorTarget.classList.add("hidden")
  }

  showSuccess(message) {
    this.successMessageTarget.textContent = message
    this.loadingTarget.classList.add("hidden")
    this.errorTarget.classList.add("hidden")
    this.successTarget.classList.remove("hidden")
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.loadingTarget.classList.add("hidden")
    this.successTarget.classList.add("hidden")
    this.errorTarget.classList.remove("hidden")
  }

  errorMessage(body) {
    const details = body?.error?.details

    if (details && typeof details === "object") {
      const messages = Object.values(details).flat().filter(Boolean)

      if (messages.length > 0) {
        return messages.join(" ")
      }
    }

    return body?.error?.message || "Account unlock could not be completed."
  }
}
